import React from 'react'
import { Helmet } from 'react-helmet'
import './WidgetHider.scss'

enum HideVariant {
  always = 'always',
  mobile = 'mobile'
}

type WidgetHiderProps = {
  variant?: `${HideVariant}`
}

export default function WidgetHider({ variant = HideVariant.always }: WidgetHiderProps): JSX.Element {
  return (
    <Helmet
      bodyAttributes={{
        'data-widget-hider': variant
      }}
    />
  )
}
